import { isApiErrorResponse, isWretchError } from '@/lib/types/predicate'
import { cn } from '@/lib/utils'

export const ApplicantCaseEoirDetailError = ({ error }: { error: Error }) => {
  return (
    <div className={cn('p-5 text-[14px] font-[400]')}>
      {isWretchError(error) && isApiErrorResponse(error.json) && error.json.code === 'NotFound'
        ? 'Case Not Found'
        : 'Error'}
    </div>
  )
}
